<div class="tabs">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs$ | async"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'state-' + tab.value + '-toggle-button'">
      {{ tab.label | i18n }}
    </a>
  </nav>
</div>
<div
  class="defaults-list"
  *ngIf="user$ | async">
  <mat-card
    class="mat-elevation-z2"
    *ngFor="let assignmentDefault of assignmentDefaults$ | async">
    <mat-card-title>
      <h2 *ngIf="assignmentDefault.department.id">
        {{ assignmentDefault.organisation.name }} -
        {{ assignmentDefault.department.name }}
      </h2>
    </mat-card-title>
    <mat-card-content>
      <div class="row">
        <div class="col">
          <app-department-select
            (departmentSelectionChanged)="
              selectDepartment(assignmentDefault, $event)
            "
            [selectedDepartmentId]="assignmentDefault.department.id || ''"
            [valid]="!!assignmentDefault.department.id"
            [excludedDepartmentIds]="(excludedDepartmentIds$ | async) ?? []">
          </app-department-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>{{
              ("description" | i18n) || "description" | titlecase
            }}</mat-label>
            <textarea
              matInput
              [placeholder]="
                ('description' | i18n) || 'description' | titlecase
              "
              [(ngModel)]="assignmentDefault.values.description"
              name="description"
              rows="7"
              data-cy="description-input">
            </textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-certificate-select
            [selectedMappedCertificates]="
              assignmentDefault.values.certificates || []
            "
            (selectionChanged)="
              certificatesSelected(assignmentDefault, $event)
            ">
          </app-certificate-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-speciality-select
            [selectedMappedSpecialities]="
              assignmentDefault.values.specialities || []
            "
            (selectionChanged)="
              specialitiesSelected(assignmentDefault, $event)
            ">
          </app-speciality-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-pooler-type-multi-select
            *ngIf="
              (customer$ | async)?.enablePoolerTypes &&
              !(customer$ | async)?.hiddenFields?.jobPoolerTypes
            "
            [selectedPoolerTypes]="assignmentDefault.values.poolerTypes || []"
            (selectionChanged)="poolerTypesSelected(assignmentDefault, $event)">
          </app-pooler-type-multi-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            mat-button
            type="button"
            class="delete-button"
            (click)="removeDefault(assignmentDefault.department.id)">
            <mat-icon svgIcon="delete-trash-remove"></mat-icon>
            <span class="mat-fab__label">
              {{ ("remove" | i18n) || "entfernen" | uppercase }}</span
            >
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="row mt-4">
    <div class="col">
      <button
        class="outline-pill-button icon-left"
        type="button"
        data-cy="add-default-button"
        (click)="addNewDefault()">
        <mat-icon
          class="custom-text-icon-button-icon"
          svgIcon="add-circle-plus"></mat-icon>
        {{ ("addDefault" | i18n) || "add default values" | titlecase }}
      </button>
    </div>
  </div>
</div>
<div class="floating-actions-bar">
  <button
    (click)="cancelChanges()"
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="cancel-assignments-defaults-button">
    <mat-icon svgIcon="close"></mat-icon>
    {{ ("cancel" | i18n) || "cancel" | titlecase }}
  </button>
  <button
    (click)="saveDefaults()"
    class="primary-pill-button icon-left big-fab"
    type="button"
    data-cy="save-assignments-defaults-button">
    <mat-icon svgIcon="save"></mat-icon>
    {{ ("save" | i18n) || "save" | titlecase }}
  </button>
</div>
